const STORAGE_PREFIX = 'accounting:hiddenForecastAccounts';

const ACCOUNT_ALIASES = {
  rds: 'rainydaysaver',
  rainyday: 'rainydaysaver',
  raindyday: 'rainydaysaver',
  rainydaysaver: 'rainydaysaver'
};

export const normalizeForecastAccountName = (value) => {
  if (!value) {
    return '';
  }

  const cleaned = String(value).toLowerCase().replace(/[^a-z0-9]/g, '');
  return ACCOUNT_ALIASES[cleaned] || cleaned;
};

const getStorageKey = (username) => `${STORAGE_PREFIX}:${username || 'anonymous'}`;

export const getHiddenForecastAccounts = (username) => {
  if (!username) {
    return [];
  }

  try {
    const raw = localStorage.getItem(getStorageKey(username));
    const parsed = JSON.parse(raw || '[]');
    if (!Array.isArray(parsed)) {
      return [];
    }
    return [...new Set(parsed.map(normalizeForecastAccountName).filter(Boolean))];
  } catch (error) {
    return [];
  }
};

export const setHiddenForecastAccounts = (username, hiddenAccounts) => {
  if (!username) {
    return;
  }

  const normalized = [...new Set((hiddenAccounts || []).map(normalizeForecastAccountName).filter(Boolean))];
  localStorage.setItem(getStorageKey(username), JSON.stringify(normalized));
};
